import React from 'react';
import { PackagePlusIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CampaignInterestForm } from './CampaignInterestForm';
const agencyUses = ['PRODUCT LAUNCHES', 'BRAND ACTIVATIONS', 'SAMPLING CAMPAIGNS', 'LOCAL DROPS', 'RETAIL ACTIVATION', 'EVENT CAMPAIGNS', 'AUDIENCE ENGAGEMENT'];
export function Manifesto() {
  const reduceMotion = useReducedMotion();
  return <>
      <section id="about" className="flex min-h-[86vh] items-center bg-white px-5 py-24 md:px-10" aria-label="Sampler brand idea" data-id="element-505" data-mp="iu2qwdtdot3o">
        <div className="mx-auto w-full max-w-[1280px]" data-id="element-506" data-mp="etisl6x2jjfy">
          <TypographyStep text="Advertising buys attention." muted data-id="element-507" data-mp="ss8owkc2df39" />
          <TypographyStep text="Sampling gives away products." muted data-id="element-508" data-mp="nsdy0gsagpi7" />
          <TypographyStep text="Sampler creates product experiences." accent data-id="element-509" data-mp="nu75tzen1frs" />
          <TypographyStep text="Experiences people choose to join." data-id="element-510" data-mp="244szhr1p8c2b" />
          <motion.p initial={reduceMotion ? false : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-20 font-display text-6xl font-bold leading-[0.8] text-[#ff4d17] md:text-9xl" data-id="element-511" data-mp="1z82lradd9sk2">
            THAT’S THE DIFFERENCE.
          </motion.p>
        </div>
      </section>

      <section id="for-agencies" className="border-y border-black/15 bg-[#f7f5ef] px-5 py-24 md:px-10 md:py-32" aria-labelledby="agency-heading" data-id="element-512" data-mp="ps6kfvvferlg">
        <div className="mx-auto max-w-[1280px]" data-id="element-513" data-mp="3oatw7zo80djt">
          <div className="grid gap-8 md:grid-cols-2 md:items-end" data-id="element-514" data-mp="3t7u5ejgd9wf5">
            <div data-id="element-515" data-mp="3t696yiqxltc0">
              <p className="text-xs font-extrabold tracking-[0.16em] text-black/45" data-id="element-516" data-mp="222eviyoghrt">
                FOR MEDIA & ACTIVATION PARTNERS
              </p>
              <h2 id="agency-heading" className="mt-5 font-display text-5xl font-bold leading-[0.9] md:text-7xl" data-id="element-517" data-mp="6uc2utg8f7rg">
                Add product experience to the media plan.
              </h2>
            </div>
            <p className="max-w-xl text-lg leading-relaxed text-black/65" data-id="element-518" data-mp="3ag1c0nxdy96w">
              Sampler gives agencies a campaign technology and experience layer
              that connects brand activity with real product experience. It is
              not a staffing or event agency.
            </p>
          </div>
          <div className="mt-14 flex flex-wrap border-y border-black/15 py-6" data-id="element-519" data-mp="3c92dzclq1fnj">
            {agencyUses.map(use => <span key={use} className="mr-6 py-2 text-sm font-extrabold tracking-[0.08em]" data-id="element-520" data-mp="379ziairmsls8">
                {use}
              </span>)}
          </div>
          <p className="mt-12 font-display text-4xl font-bold md:text-6xl" data-id="element-521" data-mp="2ek0n05mufsf4">
            One platform.
            <br data-id="element-522" data-mp="2thjbr7ziu5mk" />
            Multiple brands.
            <br data-id="element-523" data-mp="2te59s0urryfn" />
            <span className="text-[#ff4d17]" data-id="element-524" data-mp="2ohom17rhfm33">A new campaign format.</span>
          </p>
        </div>
      </section>

      <section className="bg-white px-5 py-24 md:px-10 md:py-32" aria-labelledby="more-heading" data-id="element-525" data-mp="8pr8ugh870rs">
        <div className="mx-auto max-w-[1280px]" data-id="element-526" data-mp="3rphl89nbv58">
          <p className="text-xs font-extrabold tracking-[0.16em] text-black/45" data-id="element-527" data-mp="3qwkkz0hok0a">
            BUILT FOR MORE
          </p>
          <div className="mt-5 grid gap-10 lg:grid-cols-2 lg:items-end" data-id="element-528" data-mp="g9s5mx96dqw1">
            <div data-id="element-529" data-mp="gb3az1i9r6p9">
              <h2 id="more-heading" className="font-display text-5xl font-bold leading-[0.9] md:text-7xl" data-id="element-530" data-mp="g7ffvxx6ec8f">
                Gone Fishing is the first experience.
              </h2>
            </div>
            <p className="text-lg leading-relaxed text-black/65" data-id="element-531" data-mp="6dfd42pd9j2v">
              Sampler is designed as infrastructure for interactive product
              experiences. Different products. Different audiences. Different
              campaign mechanics. One connected campaign infrastructure.
            </p>
          </div>
          <div className="mt-14 grid gap-4 md:grid-cols-3" data-id="element-532" data-mp="pa83nr75g5ti">
            <FutureModule number="01" data-id="element-533" data-mp="p8dkahbj0lrj" />
            <FutureModule number="02" data-id="element-534" data-mp="1czizqvdk1c1b" />
            <FutureModule number="03" data-id="element-535" data-mp="1cyhoapsmmnj2" />
          </div>
          <p className="mt-5 text-xs text-black/40" data-id="element-536" data-mp="1hqiym668i46g">
            PLATFORM CONCEPT — future experience infrastructure direction.
          </p>
        </div>
      </section>

      <section className="flex min-h-[82vh] items-center bg-black px-5 py-24 text-white md:px-10" aria-label="Sampler brand statement" data-id="element-537" data-mp="3q5h7pn42hv1s">
        <div className="mx-auto max-w-[1280px]" data-id="element-538" data-mp="3g94ip2jgw5dd">
          <p className="font-display text-[clamp(3.5rem,9vw,9rem)] font-bold leading-[0.82] tracking-[-0.07em]" data-id="element-539" data-mp="3g9xnhxyv8ksv">
            DON’T <span className="text-white/45" data-id="element-540" data-mp="csxodmmxzkh9">SHOW</span> THEM
            <br data-id="element-541" data-mp="csfirzee3two" />
            THE PRODUCT.
          </p>
          <motion.div initial={reduceMotion ? false : {
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-9 flex items-center gap-5" data-id="element-542" data-mp="7u467gwpn5ar">
            <span className="font-display text-4xl font-bold text-white/35 line-through decoration-[#ff4d17] decoration-4 md:text-6xl" data-id="element-543" data-mp="3v6ohfrprt4b3">
              SHOW
            </span>
            <span className="font-display text-4xl font-bold text-[#ff4d17] md:text-6xl" data-id="element-544" data-mp="qrniquidn61x">
              LET THEM CATCH IT.
            </span>
          </motion.div>
        </div>
      </section>

      <section id="start" className="bg-[#ff4d17] px-5 py-24 text-black md:px-10 md:py-32" aria-labelledby="start-heading" data-id="element-545" data-mp="2efkwmnujj3ua">
        <div className="mx-auto max-w-[1280px] text-center" data-id="element-546" data-mp="2ielf2593w4gr">
          <p className="text-xs font-extrabold tracking-[0.16em] text-black/60" data-id="element-547" data-mp="2nfhpz2rvkqvo">
            READY TO DROP SOMETHING?
          </p>
          <h2 id="start-heading" className="mx-auto mt-5 max-w-5xl font-display text-5xl font-bold leading-[0.88] md:text-8xl" data-id="element-548" data-mp="2sdszfce9czdd">
            Put your product into the experience.
          </h2>
          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-black/75" data-id="element-549" data-mp="325fan8qliyg4">
            Tell us what you are planning and we’ll start with the campaign
            context.
          </p>
          <CampaignInterestForm data-id="element-550" data-mp="3b64xvo1sjgi8" />
          <p className="mt-6 text-xs font-bold text-black/60" data-id="element-551" data-mp="3b2z9yc4weko3">
            For brands, agencies and activation partners.
          </p>
        </div>
      </section>
    </>;
}
function TypographyStep({
  text,
  muted = false,
  accent = false
}: {
  text: string;
  muted?: boolean;
  accent?: boolean;
}) {
  const reduceMotion = useReducedMotion();
  return <motion.p initial={reduceMotion ? false : {
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true,
    amount: 0.8
  }} className={`font-display text-[clamp(2.6rem,6vw,6.8rem)] font-bold leading-[0.94] ${muted ? 'text-black/30' : accent ? 'text-[#ff4d17]' : 'text-black'}`} data-id="element-552" data-mp="1psidqw23zo4r">
      {text}
    </motion.p>;
}
function FutureModule({
  number
}: {
  number: string;
}) {
  return <div className="relative min-h-[210px] overflow-hidden border border-black/15 p-5" data-id="element-553" data-mp="28pjmmrysa8dz">
      <p className="text-xs font-bold text-black/40" data-id="element-554" data-mp="23rrkz68c77wl">
        EXPERIENCE MODULE / {number}
      </p>
      <div className="absolute bottom-5 left-5 right-5 flex items-end gap-3" data-id="element-555" data-mp="ectqs4ouup3y">
        <span className="grid h-14 w-14 place-items-center border border-black/20" data-id="element-556" data-mp="9e8q645oy3ez">
          <PackagePlusIcon size={22} data-id="element-557" data-mp="2l0alabzyaj86" />
        </span>
        <span className="h-24 flex-1 border border-dashed border-black/20" data-id="element-558" data-mp="2l2nc7enos3xd" />
      </div>
    </div>;
}